// extracted by mini-css-extract-plugin
export default {"feedbackButton":"feedbackButton--NC7jT","feedbackTitle":"feedbackTitle--XCDNq","screenShotButton":"screenShotButton--m86zl","markerAnimationScale":"markerAnimationScale--NyLZh"};